module.exports = function getResource(label, vars = []) {
    let resources = {
        viewSimilarProducts: 'Voir des produits similaires'
    };

    return resources[label];
};
